import * as S from './Unauthenticated.styles'

import MediaMatch from '../mediaMatch/MediaMatch'
import loginVideo from '../../assets/video/login-video.mp4'
import { ReactNode } from 'react'
type UnauthenticatedTemplateProps = {
  children: ReactNode
  image: string
}

export default function UnauthenticatedTemplate({
  children,
  image
}: UnauthenticatedTemplateProps) {
  return (
    <S.Container>
      <S.BackgroundVideo autoPlay loop muted>
        <source src={loginVideo} type="video/mp4" />
      </S.BackgroundVideo>
      <MediaMatch greaterThan="large">
        <S.TemplateImage>
          <S.Image src={image} />
        </S.TemplateImage>
      </MediaMatch>
      <S.TemplatePage>{children}</S.TemplatePage>
    </S.Container>
  )
}
